import React, { useEffect } from 'react';
import './index.scss';
import Error from '@/components/Error';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { errorActions } from '@/reducers/Error';
import { headerActions } from '@/reducers/HeaderConfig';
import { ErrorConfig } from '@/helper/error';
const ErrorIndex = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const { key } = params;
  /**
   * @description: 更新页面标题+页面内容
   * @param {*}
   * @return {*}
   */
  useEffect(() => {
    key && dispatch(headerActions.setTitle({ title: ErrorConfig[key].title }));
    dispatch(errorActions.setFragmentEmptyError({ key }));
  }, [false]);

  return <Error />;
};
export default ErrorIndex;
